import { AnimalModel } from './animalModel'
import { BullModel } from './bullModel'
import { ContactModel } from './contactModel'
import { ConversationFileModel } from './conversationFileModel'
import { ConversationModel } from './conversationModel'
import { CropModel } from './cropModel'
import { GroupMemberModel } from './groupMemberModel'
import { GroupModel } from './groupModel'
import { MessageModel } from './messageModel'
import { MilkDeliveriesModel } from './milkDeliveriesModel'
import { MilkQualitiesModel } from './milkQualitiesModel'
import { PricesDataModel } from './pricesDataModel'
import { ProductGroupModel } from './productGroupModel'
import { ProductModel } from './productModel'
import { ProfilePictureModel } from './profilePictureModel'
import { ShoppingOrganizationModel } from './shoppingOrganizationModel'
import { SyncFileModel } from './syncFileModel'
import { SyncHistoricModel } from './syncHistoricModel'
import { SyncPendingModel } from './syncPendingModel'
import { UserModel } from './userModel'

export const models = [
  MilkDeliveriesModel,
  MilkQualitiesModel,
  PricesDataModel,
  BullModel,
  ProductModel,
  ProductGroupModel,
  CropModel,
  UserModel,
  ContactModel,
  MessageModel,
  ConversationModel,
  SyncHistoricModel,
  SyncPendingModel,
  SyncFileModel,
  ProfilePictureModel,
  GroupModel,
  GroupMemberModel,
  ConversationFileModel,
  ShoppingOrganizationModel,
  AnimalModel
]
